import dayjs from 'dayjs'
import isoWeek from 'dayjs/plugin/isoWeek'

dayjs.extend(isoWeek)

/**
 * Returns x amount of weeks starting from the current week.
 *
 * @param count - The number of weeks to return.
 */
export const getWeeks = (count: number) => {
  return Array.from({ length: count }, (_, i) => {
    const iterationWeek = dayjs().add(i, 'week')
    return `${iterationWeek.isoWeek()}-${iterationWeek.isoWeekYear()}`
  })
}

export const getWeeksObjects = (count: number, offset: number = 0) => {
  return Array.from({ length: count }, (_, i) => {
    return dayjs()
      .startOf('isoWeek')
      .add(i + offset, 'week')
  })
}
